  import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

// // 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

Vue.use(Router)

// 需要左方向动画的路由用this.$router.to('****')
Router.prototype.togo = function (path) {
  this.isleft = true
  this.isright = false
  this.push(path)
}
// 需要右方向动画的路由用this.$router.goRight('****')
Router.prototype.goRight = function (path) {
  this.isright = true
  this.isleft = false
  this.push(path)
}
// 需要返回按钮动画的路由用this.$router.goBack()，返回上一个路由
Router.prototype.goBack = function () {
  this.isright = true
  this.isleft = false
  this.go(-1)
}
// 点击浏览器返回按钮执行，此时不需要路由回退
Router.prototype.togoback = function () {
  this.isright = true
  this.isleft = false
}

Router.prototype.replace = function (path,b,c) {
  this.replace(path)
}
// 点击浏览器前进按钮执行
Router.prototype.togoin = function () {
  this.isright = false
  this.isleft = true
}

//返回初始页面
Router.prototype.reset = function () {
  window.history.go(-(window.history.length - 1))
}
Router.prototype.exitMain = function () {
  this.go(-(window.history.length - 1))
  console.log(window.history)
  this.replace('/', () => {
    location.reload()
  })
}

export default new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'welcome',
    //   component: (resolve) => require(['@/pages/welcome'], resolve)
    // },
    // {
    //   path: '/wv',
    //   name: 'webView',
    //   component: (resolve) => require(['@/pages/iframe-dialog'], resolve)
    // },
    // {
    //   path: '/af_recharge',
    //   name: 'afterRecharge',
    //   component: (resolve) => require(['@/pages/mine/rechargesuccess'], resolve)
    // },
    {
      path:'/following',
      name: 'following',
      component: (resolve) => require(['@/pages/mine/following'], resolve)
    },
    {
      path:'/uc/rec',
      name: 'Consumption',
      component: (resolve) => require(['@/pages/uc/consumptionrecord'], resolve)
    },
    {
      path:'/uc/cfg',
      name: 'Config',
      component: (resolve) => require(['@/pages/uc/ucsettings'], resolve)
    },
    {
      path:'/uc/acc',
      name: 'MineAccount',
      component: (resolve) => require(['@/pages/acc/mineaccount'], resolve)
    },
    {
      path:'/uc/rec',
      name: 'BlackRecord',
      component: (resolve) => require(['@/pages/uc/blackrecord'], resolve)
    },
    {
      path:'/uc/wallet',
      name: 'Wallet',
      component: (resolve) => require(['@/pages/uc/minewallet'], resolve)
    },
    {
      path:'/uc/pass',
      name: 'Password',
      component: (resolve) => require(['@/pages/uc/password'], resolve)
    },
    {
      path:'/uc/profile',
      name: 'UserProfile',
      component: (resolve) => require(['@/pages/uc/profile'], resolve)
    },
    {
      path:'/uc/svip',
      name: 'SvipPage',
      component: (resolve) => require(['@/pages/uc/svip'], resolve)
    },
    // {
    //   path: '/toPrivacy',
    //   name: 'privacyView',
    //   component: (resolve) => require(['@/pages/privacy'], resolve)
    // },
    // {
    //   path: '/toLogin',
    //   name: 'loginView',
    //   component: (resolve) => require(['@/pages/login'], resolve)
    // },
    // {
    //   path: '/toReg',
    //   name: 'RegisterView',
    //   component: (resolve) => require(['@/pages/reg'], resolve)
    // },
    // {
    //   path: '/toRegProfile',
    //   name: 'RegisterProfileView',
    //   component: (resolve) => require(['@/pages/reg-profile'], resolve)
    // },
    {
      path: '/',
      name: 'index',
      component: (resolve) => require(['@/pages/index'], resolve),
      meta:{
        keepAlive:true
      },
      redirect: '/home',
      children: [
        {
          path:'/uc',
          name: 'usercenter',
          component: (resolve) => require(['@/pages/mine/usercenter'], resolve),
          meta:{
            keepAlive:true
          },
        },
        {
          path: '/home',
          name: 'home',
          component: (resolve) => require(['@/pages/home'], resolve),
          meta:{
            keepAlive:true
          },
          redirect: '/live',
          children: [
            {
              path: '/live',
              name: 'live',
              meta:{
                keepAlive:true,
                scrollPos:{x:0,y:0}
              },
              component: (resolve) => require(['@/pages/live/live-lv'], resolve)
            },
            {
              path: '/hotAnchor',
              name: 'hot',
              meta:{
                keepAlive:true,
                scrollPos:{x:0,y:0}
              },
              component: (resolve) => require(['@/pages/svc/hot-svc-lv'], resolve)
            },
            {
              path: '/newAnchor',
              name: 'new',
              meta:{
                keepAlive:true,
                scrollPos:{x:0,y:0}
              },
              component: (resolve) => require(['@/pages/svc/new-svc-lv'], resolve)
            }
          ]
        },
        {
          path: '/conv',
          name: 'Conv',
          meta:{
            keepAlive:true
          },
          component: (resolve) => require(['@/pages/conv/conv-index'], resolve),
          redirect: '/chatrec',
          children: [
            {
              path: '/chatrec',
              name: 'ChatLV',
              meta:{
                keepAlive:true,
                scrollPos:{x:0,y:0}
              },
              component: (resolve) => require(['@/pages/conv/chat-lv'], resolve)
            },
            {
              path: '/callrec',
              name: 'CallLV',
              meta:{
                keepAlive:true,
                scrollPos:{x:0,y:0}
              },
              component: (resolve) => require(['@/pages/conv/call-lv'], resolve)
            },
          ]
        },
        {
          path: '/mom',
          name: 'Moment',
          meta:{
            keepAlive:true
          },
          component: (resolve) => require(['@/pages/moment/moment-index'], resolve),
          redirect: '/mhe',
          children: [
            {
              path: '/mfe',
              name: 'FollowingMoment',
              meta:{
                keepAlive:true,
                scrollPos:{x:0,y:0}
              },
              component: (resolve) => require(['@/pages/moment/moment-following-lv'], resolve)
            },
            {
              path: '/mhe',
              name: 'HotMoment',
              meta:{
                keepAlive:true,
                scrollPos:{x:0,y:0}
              },
              component: (resolve) => require(['@/pages/moment/moment-hot-lv'], resolve)
            },
            {
              path: '/mne',
              name: 'NewMoment',
              meta:{
                keepAlive:true,
                scrollPos:{x:0,y:0}
              },
              component: (resolve) => require(['@/pages/moment/moment-new-lv'], resolve)
            },
          ]
        },

      ]
    },
    {
      path: '/mom/comment',
      name: 'MomentMineComment',
      component: (resolve) => require(['@/pages/moment/moment-mine-comment'], resolve)
    },
    {
      path: '/mom/detail',
      name: 'MomentDetail',
      component: (resolve) => require(['@/pages/moment/moment-detail'], resolve)
    },
    {
      path: '/mom/comment/detail',
      name: 'CommentDetail',
      component: (resolve) => require(['@/pages/moment/comment-detail'], resolve)
    },
    {
      path: '/conv/chat',
      name: 'ChatRoom',
      component: (resolve) => require(['@/pages/conv/chat-room'], resolve)
    },
    {
      path: '/live/detail',
      name: 'LiveRoomDetail',
      component: (resolve) => require(['@/pages/live/roomdetail'], resolve)
    },
    {
      path: '/voice/detail',
      name: 'VoiceRoomDetail',
      component: (resolve) => require(['@/pages/voice/roomdetail'], resolve)
    },
    {
      path: '/svc/search',
      name: 'SearchPage',
      meta:{
        keepAlive:true,
        scrollPos:{x:0,y:0,type:1}
      },
      component: (resolve) => require(['@/pages/svc/search'], resolve)
    },
    {
      path: '/svc/detail',
      name: 'AnchorInfoDetail',
      component: (resolve) => require(['@/pages/svc/anchorinfo'], resolve)
    },
    {
      path: '/svc/aal',
      name: 'AvailableAnchorList',
      component: (resolve) => require(['@/pages/svc/available-anchor-lv'], resolve)
    },
    {
      path: '/svc/call',
      name: 'CallRoom',
      component: (resolve) => require(['@/pages/svc/call/call'], resolve)
    },
    {
      path: '/svc/calldetail',
      name: 'CallRoomDetail',
      component: (resolve) => require(['@/pages/svc/call/calldetail'], resolve)
    },
    {
      path: '/svc/callec',
      name: 'CallEndComment',
      component: (resolve) => require(['@/pages/svc/call/callend'], resolve)
    },
    {
      path: '/hc',
      name: 'HtmlContent',
      component: (resolve) => require(['@/pages/htmlcontent'], resolve)
    }

  ],
  scrollBehavior(to){
    const {scrollPos={}}=to.meta
    return scrollPos
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js